// extracted by mini-css-extract-plugin
module.exports = {"search":"searchbar_search__t0UcX","clearButton":"searchbar_clearButton__Pq9R_","searchButton":"searchbar_searchButton__Wjda5","suggestions":"searchbar_suggestions__9hIYq"};